import { Reducer, FleetReportData } from '../../../../@types';
import { ReportsTypes } from '../../../../@types/enums/redux/store/ReportsTypes';
import { initialState, ReportsState } from './initialState';
// @ts-ignore
export const reportsReducer: Reducer<ReportsState> = (
  state = initialState,
  action
) => {
  switch (action.type as any) {
    case ReportsTypes.REPORTS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ReportsTypes.REPORTS_SUCCESS:
      return {
        ...state,
        entities: action.payload,
        loading: false,
      };
    case ReportsTypes.REPORTS_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    case ReportsTypes.SET_DISPLAY_REPORTS:
      return {
        ...state,
        display: action.payload,
      };
    case ReportsTypes.SELECT_REPORT:
      return {
        ...state,
        selected: action.payload,
      };
    case ReportsTypes.REPORT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ReportsTypes.REPORT_SUCCESS:
      return {
        ...state,
        selected: action.payload,
        loading: false,
      };
    case ReportsTypes.REPORT_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    case ReportsTypes.REGENERATE_REPORT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ReportsTypes.REGENERATE_REPORT_SUCCESS: {
      const updatedReport: FleetReportData = action.payload;
      const updateRow = (list: FleetReportData[] | null) =>
        list?.map((report) =>
          report.id === updatedReport.id ? updatedReport : report
        ) ?? list;
      return {
        ...state,
        loading: false,
        entities: updateRow(state.entities),
        display: updateRow(state.display),
        selected:
          state.selected?.id === updatedReport.id
            ? updatedReport
            : state.selected,
      };
    }
    case ReportsTypes.REGENERATE_REPORT_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    default:
      return state;
  }
};
